import { Directive, HostListener, ElementRef, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Directive({
  selector: '[appNumberOnly]'
})
export class NumberOnlyDirective implements OnInit {
  @Input('numericType') numericType: string = 'number'; // number | decimal

  private regex = {
    number: new RegExp(/^\d+$/),
    decimal: new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g)
    //decimal: new RegExp(/^(?:\d*\.\d{1,2}|\d+)$/)
  };

  private specialKeys = {
    number: ['Enter', 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Control', 'v', 'V', 'c', 'C'],
    decimal: ['Enter', 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Control', 'v', 'V', 'c', 'C'],
  };

  constructor(private el: ElementRef, private platform: Platform) {
  }

  ngOnInit() {

    if (this.platform.is('ios')) {    
      this.el.nativeElement.attributes.type = "text"  
      this.el.nativeElement.inputmode = "decimal"
 
    }
    
    
  }


  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys[this.numericType].indexOf(event.key) !== -1) {
      return;
    }
    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    let current: string = this.el.nativeElement.value;
    const decimalSplitString = current.split('.');
    if (decimalSplitString.length > 1) {
      const decimalLengths = decimalSplitString[1].length;
      if (decimalLengths >= 2) {
        event.preventDefault();
        return;  
      }
    }
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex[this.numericType])) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this.el.nativeElement.value;
    if (this.numericType === 'decimal') {
      if(initalValue && initalValue.split('.').length > 2) {
        this.el.nativeElement.value = '';
        event.stopPropagation();
        return;
      }
      this.el.nativeElement.value = initalValue.replace(/[^0-9.]*/g, '');
      if ( initalValue !== this.el.nativeElement.value) {
        event.stopPropagation();
      }
    } else {
      this.el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
      if ( initalValue !== this.el.nativeElement.value) {
        event.stopPropagation();
      }
    }
  }
}
